/* Groovd Webkit units + dates (7.10.2026). One file for the Shopify theme and the CheckoutChamp pages
   (build_cc.py inlines it right after the currency script).

   US visitors read inches, ounces and fl oz; everyone else reads cm, mm, g and ml. Every measurement
   in the page text is rewritten the moment it arrives, before it is drawn:
     "60 x 50 cm (24 x 20 in)"  ->  "60 x 50 cm" (metric) or "24 x 20 in" (US): the visitor's half only
     "43 x 28 inches"           ->  "109 x 71 cm"          "140 g" -> "4.9 oz"     "2.1 fl oz" -> "62 ml"
   Left alone: screen sizes ("8.5 inch LCD", '8.5" Screen' are inches everywhere), and "in" that is
   not a unit ("3 in 4 of them", "48 in the basic set", "3 to 8 in one box").
   Dates: US "Oct 12" and "10/31/2026", everyone else "12 Oct" and "31/10/2026" (gwLocale.date).

   Country, best first: CheckoutChamp's geo lookup (CC pages), the IP country the Shopify theme looked
   up (sessionStorage gwVisitorCountry), the CC country remembered from an earlier visit, Shopify's
   market country when it is not the default US, then the phone's time zone. A better source arriving
   later switches the page over (event "gw:locale").
   QA: ?gw_units=imperial or ?gw_units=metric forces the units for this page view. */
(function () {
  try {
    var IMPERIAL = { US: 1, PR: 1, GU: 1, VI: 1, AS: 1, MP: 1, UM: 1, LR: 1, MM: 1 };
    var US_DATES = { US: 1, PR: 1, GU: 1, VI: 1, AS: 1, MP: 1, UM: 1 };
    var US_ZONE = /^(America\/(New_York|Detroit|Chicago|Denver|Boise|Phoenix|Los_Angeles|Anchorage|Juneau|Sitka|Metlakatla|Yakutat|Nome|Adak|Menominee|Puerto_Rico|St_Thomas)|America\/(Indiana|Kentucky|North_Dakota)\/.+|Pacific\/(Honolulu|Guam|Pago_Pago|Saipan)|US\/.+)$/;

    function ss(k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }
    function ls(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
    function json(s) { try { return JSON.parse(s || 'null'); } catch (e) { return null; } }
    function param(n) { var m = new RegExp('[?&]' + n + '=([^&#]*)', 'i').exec(location.search); return m ? decodeURIComponent(m[1]).toLowerCase() : ''; }
    function ccGeo() { var x = json(ss('sessionId')); return (x && x.message && x.message.geoInfo && x.message.geoInfo.geoCountry) || ''; }
    function tzCountry() { try { return US_ZONE.test(Intl.DateTimeFormat().resolvedOptions().timeZone || '') ? 'US' : ''; } catch (e) { return ''; } }

    var country = '', source = '';
    (function pick() {
      var c = ccGeo(); if (c) { country = c; source = 'checkoutchamp'; return; }
      var v = json(ss('gwVisitorCountry')); if (v && v.code) { country = v.code; source = 'ip'; return; }
      var r = json(ls('gv_cc_country')); if (r && r.c && Date.now() - r.t < 7 * 86400000) { country = r.c; source = 'remembered'; return; }
      var s = window.GW_LOC && window.GW_LOC.country; if (s && s !== 'US') { country = s; source = 'shopify'; return; }
      var g = window.gvCurrency && window.gvCurrency.country; if (g) { country = g; source = 'currency'; return; }
      country = tzCountry(); source = 'timezone';
    })();
    country = String(country || '').toUpperCase();
    var forced = param('gw_units');
    function systemFor(c) { return forced === 'imperial' || forced === 'metric' ? forced : (IMPERIAL[c] ? 'imperial' : 'metric'); }
    var system = systemFor(country);

    /* ---------------- measurements ---------------- */
    /* unit -> [system, dimension, size in cm / g / ml, word?] */
    var U = {
      'mm': ['metric', 'len', 0.1], 'cm': ['metric', 'len', 1], 'millimeter': ['metric', 'len', 0.1, 1], 'centimeter': ['metric', 'len', 1, 1],
      'meter': ['metric', 'len', 100, 1], 'in': ['imperial', 'len', 2.54], 'inch': ['imperial', 'len', 2.54, 1], 'ft': ['imperial', 'len', 30.48],
      'foot': ['imperial', 'len', 30.48, 1], 'g': ['metric', 'mass', 1], 'kg': ['metric', 'mass', 1000], 'gram': ['metric', 'mass', 1, 1],
      'kilogram': ['metric', 'mass', 1000, 1], 'oz': ['imperial', 'mass', 28.3495], 'ounce': ['imperial', 'mass', 28.3495, 1],
      'lb': ['imperial', 'mass', 453.592], 'ml': ['metric', 'vol', 1], 'milliliter': ['metric', 'vol', 1, 1], 'liter': ['metric', 'vol', 1000, 1],
      'floz': ['imperial', 'vol', 29.5735]
    };
    function unitKey(u) {
      var s = u.toLowerCase().replace(/\s+/g, '').replace(/\./g, '');
      if (s === 'floz') return 'floz';
      if (s === 'lbs') return 'lb';
      if (s === 'inches') return 'inch';
      if (s === 'feet') return 'foot';
      s = s.replace(/metre/, 'meter').replace(/litre/, 'liter').replace(/s$/, '');
      return U[s] ? s : '';
    }
    var NUM = '\\d+(?:\\.\\d+)?';
    var VAL = NUM + '(?:\\s?[-–—]\\s?' + NUM + '|\\sto\\s' + NUM + ')?';
    var SEQ = VAL + '(?:(?:\\s?[x×*]\\s?|\\sby\\s)' + VAL + ')*';
    var UNIT = 'fl\\.?\\s?oz|[Cc]entimet(?:er|re)s?|[Mm]illimet(?:er|re)s?|[Mm]et(?:er|re)s?|[Kk]ilograms?|[Gg]rams?|[Mm]illilit(?:er|re)s?|[Ll]it(?:er|re)s?|[Ii]nch(?:es)?|[Ff]eet|[Ff]oot|[Oo]unces?|lbs?|kg|cm|mm|ml|ft|oz|in|g';
    var MEAS = '(' + SEQ + ')\\s?(' + UNIT + ')(?![A-Za-z0-9])';
    var RE_PAIR = new RegExp('(^|[^\\w.$£€])' + MEAS + '\\s?\\(\\s?(?:about\\s|approx\\.?\\s|~\\s?)?' + MEAS + '\\s?\\)', 'g');
    var RE_ONE = new RegExp('(^|[^\\w.$£€])' + MEAS, 'g');
    var HINT = /\d\s?(?:fl|cm|mm|ml|kg|g|in|ft|oz|lb|[Cc]entim|[Mm]illim|[Mm]et|[Kk]ilog|[Gg]ram|[Ll]it|[Ii]nch|[Ff]ee|[Ff]oo|[Oo]unc)/;
    var SCREEN_AFTER = /^\s*(?:LCD|LED|screen|display|tablet|monitor|e-?ink)\b/i;
    var IN_AFTER = /^(?:$|\.(?!\d)|[,;:)!?\/]|\s+(?:long|wide|tall|high|deep|thick|across|square|in diameter|diameter|x|×)\b)/;

    function nice(v, dim, unit) {
      if (dim === 'mass' && (unit === 'g') || dim === 'vol' && unit === 'ml') return String(Math.round(v));
      if (v >= 10) return String(Math.round(v));
      var s = v.toFixed(1);
      if (s === '0.0') s = v.toFixed(2);
      return s.replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
    }
    /* "60 x 50", "48-192", "43 by 28": convert every number, keep the separators */
    function convertSeq(seq, factor, dim, unit) {
      return seq.replace(new RegExp(NUM, 'g'), function (n) { return nice(Number(n) * factor, dim, unit); });
    }
    function maxOf(seq) { var m = 0; (seq.match(new RegExp(NUM, 'g')) || []).forEach(function (n) { m = Math.max(m, Number(n)); }); return m; }
    function convert(seq, unitText, want) {
      var k = unitKey(unitText), u = U[k];
      if (!u || u[0] === want) return null;
      var base = u[2], dim = u[1], word = !!u[3], big = maxOf(seq) * base, out, f;
      if (want === 'imperial') {
        if (dim === 'len') { if (k === 'meter') { out = word ? 'feet' : 'ft'; f = base / 30.48; } else { out = word ? 'inches' : 'in'; f = base / 2.54; } }
        else if (dim === 'mass') { if (big / 28.3495 >= 16) { out = word ? 'pounds' : 'lb'; f = base / 453.592; } else { out = word ? 'ounces' : 'oz'; f = base / 28.3495; } }
        else { out = 'fl oz'; f = base / 29.5735; }
      } else {
        if (dim === 'len') { if (big >= 100 && k === 'foot') { out = 'm'; f = base / 100; } else { out = 'cm'; f = base; } }
        else if (dim === 'mass') { if (big >= 1000) { out = 'kg'; f = base / 1000; } else { out = 'g'; f = base; } }
        else { if (big >= 1000) { out = 'l'; f = base / 1000; } else { out = 'ml'; f = base; } }
      }
      var unitOut = out === 'g' || out === 'ml' ? out : '';
      var nums = convertSeq(seq, f, dim, unitOut);
      if (word && /^(inches|ounces|pounds|feet)$/.test(out) && /^1(\.0+)?$/.test(nums)) out = { inches: 'inch', ounces: 'ounce', pounds: 'pound', feet: 'foot' }[out];
      return [nums, out];
    }
    function systemOf(unitText) { var u = U[unitKey(unitText)]; return u ? u[0] : ''; }
    function isScreen(unitText, before, after) {
      var k = unitKey(unitText);
      if (k !== 'in' && k !== 'inch') return false;
      return SCREEN_AFTER.test(after) || /screen\s*$/i.test(before);
    }

    function convertText(text, want) {
      if (!HINT.test(text)) return text;
      /* "A (B)" with one metric and one imperial half: keep the visitor's half */
      text = text.replace(RE_PAIR, function (m, pre, s1, u1, s2, u2) {
        var a = systemOf(u1), b = systemOf(u2);
        if (!a || !b || a === b) return m;
        return pre + (a === want ? s1 + ' ' + u1 : s2 + ' ' + u2);
      });
      return text.replace(RE_ONE, function (m, pre, seq, unit, off, all) {
        var end = off + m.length, after = all.slice(end), before = all.slice(0, off + pre.length);
        var k = unitKey(unit);
        if (k === 'in' && (!IN_AFTER.test(after) || /^\s*\d/.test(after))) return m;
        if (isScreen(unit, before, after)) return m;
        var c = convert(seq, unit, want);
        return c === null ? m : pre + c[0] + ' ' + c[1];
      });
    }

    /* ---------------- the page ---------------- */
    var registry = [];
    function render(node) { var v = convertText(node.__gwU, system); if (node.nodeValue !== v) node.nodeValue = v; }
    function take(node) {
      if (node.__gwU !== undefined) return;
      var p = node.parentNode, tag = p && p.nodeName;
      if (!p || tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'NOSCRIPT' || tag === 'TEMPLATE') return;
      var t = node.nodeValue;
      if (!t || !HINT.test(t)) return;
      /* a price in the same text belongs to the currency script, which rewrites the whole text */
      if (/\$\s?\d/.test(t)) return;
      if (p.closest && p.closest('[data-no-units]')) return;
      node.__gwU = t;
      registry.push(node);
      render(node);
    }
    /* spec cards with the number and the unit in two elements: <b>60x50</b><span>cm</span> */
    var SPLIT = '.pdp__spec,[data-units-split]', RE_SEQ = new RegExp('^' + SEQ + '$'), RE_UNIT = new RegExp('^(?:' + UNIT + ')$');
    var splits = [];
    function renderSplit(el) {
      var s = el.__gwS, c = convert(s.n, s.u, system);
      s.nb.textContent = c ? c[0] : s.n; s.ub.textContent = c ? c[1] : s.u;
    }
    function takeSplit(el) {
      if (el.__gwS) return;
      var nb = el.firstElementChild, ub = nb && nb.nextElementSibling;
      if (!nb || !ub) return;
      var n = nb.textContent.trim(), u = ub.textContent.trim();
      if (!RE_SEQ.test(n) || !RE_UNIT.test(u)) return;
      el.__gwS = { n: n, u: u, nb: nb, ub: ub };
      splits.push(el);
      renderSplit(el);
    }
    function walk(root) {
      var host = root.nodeType === 3 ? root.parentNode : root;
      if (host && host.closest) { var sp = host.closest(SPLIT); if (sp) takeSplit(sp); }
      if (root.nodeType === 1 && root.querySelectorAll) { var all = root.querySelectorAll(SPLIT); for (var q = 0; q < all.length; q++) takeSplit(all[q]); }
      if (root.nodeType === 3) { take(root); return; }
      if (root.nodeType !== 1 && root.nodeType !== 11) return;
      var w = document.createTreeWalker(root, 4, null, false);
      for (var n = w.nextNode(); n; n = w.nextNode()) take(n);
    }
    function rerender() {
      for (var i = 0; i < registry.length; i++) { try { render(registry[i]); } catch (e) {} }
      for (var j = 0; j < splits.length; j++) { try { renderSplit(splits[j]); } catch (e) {} }
    }
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { var a = muts[i].addedNodes; for (var j = 0; j < a.length; j++) walk(a[j]); }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    document.addEventListener('DOMContentLoaded', function () { walk(document.body); });

    function dateLocale() { return US_DATES[country] ? 'en-US' : 'en-GB'; }
    function publish(why) {
      window.gwLocale.country = country; window.gwLocale.system = system; window.gwLocale.source = why;
      window.gwLocale.dateLocale = dateLocale();
    }
    window.gwLocale = {
      convertText: convertText,
      date: function (d, opts) { return d.toLocaleDateString(dateLocale(), opts); },
      setCountry: function (c, why) {
        c = String(c || '').toUpperCase();
        if (!/^[A-Z]{2}$/.test(c) || c === country) return;
        var oldSystem = system, oldDates = dateLocale();
        country = c; system = systemFor(c);
        publish(why || 'set');
        if (system !== oldSystem) rerender();
        if (system !== oldSystem || dateLocale() !== oldDates) {
          try { document.dispatchEvent(new CustomEvent('gw:locale', { detail: window.gwLocale })); } catch (e) {}
        }
      }
    };
    publish(source);

    /* CheckoutChamp pages: its geo lookup lands in sessionStorage a moment after load */
    if (source !== 'checkoutchamp' && !window.GW_LOC) {
      var n = 0, t = setInterval(function () { var c = ccGeo(); if (c) { window.gwLocale.setCountry(c, 'checkoutchamp'); clearInterval(t); } else if (++n > 120) clearInterval(t); }, 500);
    }
  } catch (e) {}
})();
